module.exports = __webpack_public_path__ + "img/pitches-cta-bg.14c8b3d.png";